import { stopReload } from '@vindr/utils/helpers/common.helper';
import classnames from 'classnames';
import { memo, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useCaptureState } from '../context';
import PauseIcon from './PauseIcon';
import './RecordIcon.css';

const RecordIcon = ({
  className = '',
  title,
  disabled,
}: {
  className?: string;
  title: string;
  disabled: boolean;
}) => {
  const { t } = useTranslation('Vindoc');
  const { mediaRecorder, startRecord, stopRecord } = useCaptureState();
  const isRecording = useMemo(
    () => ['recording', 'paused'].includes(mediaRecorder?.state),
    [mediaRecorder?.state]
  );

  const handleClick = useCallback(() => {
    if (disabled) return;

    if (isRecording) {
      stopRecord();
      window.removeEventListener('beforeunload', stopReload, { capture: true });
    } else {
      startRecord();
      window.addEventListener('beforeunload', stopReload, { capture: true });
    }
  }, [disabled, isRecording, startRecord, stopRecord]);

  return (
    <div
      className={classnames(`btn-record`, className, {
        'disabled cursor-not-allowed opacity-50': disabled,
      })}
    >
      <div
        className={classnames('record-wrapper', {
          'active': isRecording,
        })}
        onClick={handleClick}
        title={disabled ? t('Please allow access to your camera and microphone') : title}
      >
        <svg width="46" height="46" className="btn-record-timer">
          <defs>
            <mask id="circleMask">
              <rect height="46" width="46" fill="white" />
              <circle r="18" cx="23" cy="23" fill="black" />
            </mask>
          </defs>
          <circle r="23" cx="23" cy="23" fill="#64686B" mask="url(#circleMask)" />
          <path
            id="timerArc"
            fill="#ffffff"
            strokeWidth="0"
            mask="url(#circleMask)"
            d="M 23 23 L 22.999999999999996 0 A 23 23 0 0 0 22.999999999999996 0 L 23 23"
          />
        </svg>
        <i className="icn-record" />
      </div>
      <PauseIcon className="absolute top-1/2 -translate-x-1/2 -translate-y-1/2 transform" />
    </div>
  );
};

export default memo(RecordIcon);
